import { gsap } from 'gsap'

/*
* Add new custom animations here.
*
* Important: to prevent flashing on load opacity 0 is added with CSS.
*  - autoAlpha value needs to be added always.
*  - if you don't want the opacity to be animated, add autoAlpha: 1 in both props1 and props2.
*  - force3D: true is recommended for better performance and macOS compatibility.
*/
const gsapEffects = [
	{ 
		id: "none",
		animate: 'fromTo',
		props1: { force3D: true },
		props2: { force3D: true }
	},
	{ 
		id: "fade-in",
		animate: 'fromTo',
		props1: { autoAlpha: 0, force3D: true },
		props2: { autoAlpha: 1, force3D: true }
	},
	{
		id: "fade-up",
		animate: 'fromTo',
		props1: { autoAlpha: 0, x:0, y: '100px', force3D: true },
		props2: { autoAlpha: 1, x: 0, y: '0px', force3D: true }
	},
	{
		id: "fade-down",
		animate: 'fromTo',
		props1: { autoAlpha: 0, x:0, y: '-100px', force3D: true },
		props2: { autoAlpha: 1, x: 0, y: '0px', force3D: true }
	},
	{
		id: "fade-left",
		animate: 'fromTo',
		props1: { autoAlpha: 0, x: '100px', y: 0, force3D: true },
		props2: { autoAlpha: 1, x: '0', y: 0, force3D: true }
	},
	{
		id: "fade-right",
		animate: 'fromTo',
		props1: { autoAlpha: 0, x: '-100px', y: 0, force3D: true },
		props2: { autoAlpha: 1, x: '0', y: 0, force3D: true }
	},
	{
		id: "slide-up",
		animate: 'fromTo',
		props1: { autoAlpha: 1, x: 0, y: '100px', force3D: true },
		props2: { autoAlpha: 1, x: 0, y: '0', force3D: true }
	},
	{
		id: "slide-down",
		animate: 'fromTo',
		props1: { autoAlpha: 1, x: 0, y: '-100px', force3D: true },
		props2: { autoAlpha: 1, x: 0, y: '0', force3D: true }
	},
	{
		id: "slide-left",
		animate: 'fromTo',
		props1: { autoAlpha: 1, x: '100px', y: 0, force3D: true },
		props2: { autoAlpha: 1, x: '0', y: 0, force3D: true }
	},
	{
		id: "slide-right",
		animate: 'fromTo',
		props1: { autoAlpha: 1, x: '-100px', y: 0, force3D: true },
		props2: { autoAlpha: 1, x: '0', y: 0, force3D: true }
	},
	{
		id: "mask-right",
		animate: 'fromTo',
		props1: { autoAlpha: 1, clipPath: 'inset( 0% 100% 0% 0% )', force3D: true },
		props2: { autoAlpha: 1, clipPath: 'inset( 0% 0% 0% 0% )', force3D: true }
	},
	{
		id: "mask-left",
		animate: 'fromTo',
		props1: { autoAlpha: 1, clipPath: 'inset( 0% 0% 0% 100% )', force3D: true },
		props2: { autoAlpha: 1, clipPath: 'inset( 0% 0% 0% 0% )', force3D: true }
	},
	{
		id: "mask-sides",
		animate: 'fromTo',
		props1: { autoAlpha: 1, clipPath: 'inset(0% 20% 0% 20%)', force3D: true },
		props2: { autoAlpha: 1, clipPath: 'inset( 0% 0% 0% 0% )', force3D: true }
	},
	{
		id: "mask-top",
		animate: 'fromTo',
		props1: { autoAlpha: 1, clipPath: 'inset( 0% 0% 100% 0% )', force3D: true },
		props2: { autoAlpha: 1, clipPath: 'inset( 0% 0% 0% 0% )', force3D: true }
	},
	{
		id: "mask-bottom",
		animate: 'fromTo',
		props1: { autoAlpha: 1, clipPath: 'inset( 100% 0% 0% 0% )', force3D: true },
		props2: { autoAlpha: 1, clipPath: 'inset( 0% 0% 0% 0% )', force3D: true }
	},
	{
		id: "mask-smaller-bottom",
		animate: 'fromTo',
		props1: { autoAlpha: 1, clipPath: 'inset( 50% 0% 0% 0% )', force3D: true },
		props2: { autoAlpha: 1, clipPath: 'inset( 0% 0% 0% 0% )', force3D: true }
	},
	{
		// For this animation to work, the element needs to have a parent with overflow hidden.
		id: "unhide",
		animate: 'fromTo',
		props1: { autoAlpha: 1, yPercent: 100, force3D: true },
		props2: { autoAlpha: 1, yPercent: 0, force3D: true }
	},
	{
		id: "slide-and-mask-left",
		animate: 'fromTo',
		props1: { autoAlpha: 1, xPercent: 20, clipPath: 'inset(0% 0% 0% 100%)', force3D: true },
		props2: { autoAlpha: 1, xPercent: 0, clipPath: 'inset(0% 0% 0% 0%)', force3D: true }
	},
	{
		id: "slide-and-mask-right",
		animate: 'fromTo',
		props1: { autoAlpha: 1, xPercent: -20, clipPath: 'inset(0% 100% 0% 0%)', force3D: true },
		props2: { autoAlpha: 1, xPercent: 0, clipPath: 'inset(0% 0% 0% 0%)', force3D: true }
	},
	{
		id: "slide-and-mask-left--banner",
		animate: 'fromTo',
		props1: { autoAlpha: 1, xPercent: 20, clipPath: 'inset(0% 0% 10% 100%)', force3D: true },
		props2: { autoAlpha: 1, xPercent: 0, clipPath: 'inset(0% 0% 10% 0%)', force3D: true }
	},
	{
		id: "slide-and-mask-right--banner",
		animate: 'fromTo',
		props1: { autoAlpha: 1, xPercent: -20, clipPath: 'inset(0% 100% 10% 0%)', force3D: true },
		props2: { autoAlpha: 1, xPercent: 0, clipPath: 'inset(0% 0% 10% 0%)', force3D: true }
	}
];


function twkAnimations() {
	gsapEffects.forEach( effect => {
		gsap.registerEffect({
			name: effect.id,
			extendTimeline: true,

			effect( targets, config ) {
				if ( effect.animate === 'from' ){
					return gsap.from( targets, { ...effect.props1, ...config } )
				} 
				else if ( effect.animate === 'fromTo' ){
					return gsap.fromTo( targets, { ...effect.props1 }, { ...effect.props2, ...config } )
				} else {
					return gsap.to( targets, { ...effect.props1, ...config } )
				}
			}
		});
	});
}

export { twkAnimations, gsapEffects }